/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Agent_NoteInputs */

const en_mk_tb_agent_note = /** @type {(inputs: Mk_Tb_Agent_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Build coordinates people using their own tools. Agent teams provide a separate workflow for orchestrating AI workers.`)
};

const id_mk_tb_agent_note = /** @type {(inputs: Mk_Tb_Agent_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Build mengoordinasikan orang dengan alat masing-masing. Tim agent menyediakan alur terpisah untuk mengatur pekerja AI.`)
};

/**
* | output |
* | --- |
* | "Team Build coordinates people using their own tools. Agent teams provide a separate workflow for orchestrating AI workers." |
*
* @param {Mk_Tb_Agent_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_agent_note = /** @type {((inputs?: Mk_Tb_Agent_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Agent_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_agent_note(inputs)
	return en_mk_tb_agent_note(inputs)
});